export default {
    'en_CA': 'English (Canada)',
    'en_US': 'English (United States)',
    'en_GB': 'English (Great Britain)',
    'fr_CA': 'French (Canada)',
    'fr_FR': 'French (France)',
	'fr_BE': 'French (Belgium)',
	'fr_MA': 'French (Morocco)',
    'pt_PT': 'Portuguese (Portugal)',
	'el_GR': 'Greek (Greece)',
	'es_ES': 'Spanish (Spain)',
	'es_MX': 'Spanish (Mexico)',
	'es_CO': 'Spanish (Colombia)',
	'nl_BE': 'Dutch (Belgium)',
	'pt_BR': 'Portuguese (Brazil)',
	'sk_SK': 'Slovak (Slovakia)',
	'sr_RS': 'Serbian (Serbia)',
	'tr_TR': 'Turkish (Turkey)',
    'fi_FI': 'Finnish (Finland)',
    'sv_SE': 'Swedish (Sweden)',
    // GAME_SUSPENDED_MESSAGE: 'Game {0} is currently suspended...',  {0} = game name EXAMPLE WITH WILD CARD market types
    WIN_DRAW_WIN: 'Maç Sonucu',
    CORRECT_SCORE: 'Maç Skoru',
    TOTAL_GOALS: 'Toplam Gol',
    DOUBLE_CHANCE: 'Çifte Şans',
    UNDER_OVER: 'Üst/Alt',
    UNDER_OVER_25: '2.5 Üst/Alt',
    UNDER_OVER_25_INITIALS: 'Ü/A 2.5',
    UNDER_OVER_35_INITIALS: 'Ü/A 3.5',
    UNDER_OVER_15: '1.5 Üst/Alt',
    ASIAN_HANDICAP: 'Asian Handicap',
    HANDICAP: '1X2 Handikap',
    HANDICAP_FIRST: '1X2 Handikap Ev Sahibi +1',
    HANDICAP_SECOND: '1X2 Handikap Deplasman +1',
    UNDER_OVER_05: '0.5 Alt/Üst',
    UNDER_OVER_35: '3.5 Üst/Alt',
    BOTH_TEAMS_SCORE: 'Karşılıklı Gol',
    BOTH_TEAMS_SCORE_INITIALS: 'KARŞILIKLI GOL',
    HOME_TEAM_GOALS: '{0}. Takım Gol Atar',
    AWAY_TEAM_GOALS: '{1}. Takım Gol Atar',
    MATCH_BETTING_BOTH_TEAMS_SCORE: 'Match Betting Both Teams Score',
    WINNING_MARGIN: 'Kazanma Farkı',
    CORRECT_SCORE_GROUP: 'Maç Skoru Grubu',
    HOME_TEAM_TO_SCORE: '{0} Gol Atar',
    AWAY_TEAM_TO_SCORE: '{1} Gol Atar',
    FIRST_TEAM_TO_SCORE: 'İlk Golü Atan',
    LAST_TEAM_TO_SCORE: 'Son Golü Atan',
    HALF_TIME_FULL_TIME: 'İlk Yarı Maç Sonucu',
    TEAM_SCORECAST: 'Takım Skor Tahmini',
    HALF_TIME_CORRECT_SCORE: 'Doğru İlk Yarı Skoru',
    HALF_TIME_RESULT: 'İlk Yarı Sonucu',
    FIRST_LAST_TO_SCORE: 'İlk / Son Gol',
    LAST: 'Son',
    FIRST: 'İlk',
    IN: 'içinde',
    LAST_THREE_GAMES: 'Son 3 Maç',
    PREVIOUS: 'Son',
    EIGHT_RESULTS: '8 Maç',
    EIGHT_GAMES: '8 Maç',
    OVER_25: '2.5 Üstü',
    UNDER_25: '2.5 Altı',
    OVER_35: '3.5 Üstü',
    UNDER_35: '3.5 Altı',
    COVERED: 'Gerçekleşti',
    DID_NOT_COVER: 'Gerçekleşmedi',
    SPREAD: 'Handikap',
    TOTAL_POINTS_UNDER_OVER: 'Toplam Sayı Alt/Üst',
    TOTAL_POINTS_OVER_UNDER: 'Toplam Sayı Üst/Alt',
    MONEYLINE: 'Maç Sonucu',
    TOTAL_POINTS_GROUP: 'Toplam Sayı',
    MONEY_LINE_TOTAL_POINTS: 'Maç Sonucu ve Toplam Sayı Ü/A',
    SPREAD_TOTAL_POINTS: 'Handikap ve Toplam Sayı Ü/A',
    // countries (these are lowecase and strings on purpose)
    'Argentina': 'Arjantin',
    'Belgium': 'Belçika',
    'Brazil': 'Brezilya',
    'Colombia': 'Kolombiya',
    'Costa Rica': 'Kosta Rika',
    'Croatia': 'Hırvatistan',
    'Czech Republic': 'Çekya',
    'Denmark': 'Danimarka',
    'Egypt': 'Mısır',
    'England': 'İngiltere',
    'France': 'Fransa',
    'Germany': 'Almanya',
    'Greece': 'Yunanistan',
    'Holland': 'Hollanda',
    'Iceland': 'İzlanda',
    'Italy': 'İtalya',
    'Mexico': 'Meksika',
    'Poland': 'Polonya',
    'Portugal': 'Portekiz',
    'Republic of Ireland': 'İrlanda Cumhuriyeti',
    'Russia': 'Rusya',
    'Spain': 'İspanya',
    'Sweden': 'İsveç',
    'Switzerland': 'Switzerland',
    'Ukraine': 'Ukrayna',
    'Uruguay': 'Uruguay',
    //Basketball US Teams
    'Boston': 'Boston',
    'Cleveland': 'Cleveland',
    'Houston': 'Houston',
    'Los Angeles': 'Los Angeles',
    'Orlando': 'Orlando',
    'Portland': 'Portland',
    'San Antonio': 'San Antonio',
    //Basketball Euro Teams
    'Euro Arena': 'Euro Arena',
    'Athens': 'Athens',
    'Real': 'Real',
    'Piraeus': 'Piraeus',
    'Istanbul Blues': 'Istanbul Blues',
    'Fener': 'Fener',
    'Vitoria': 'Vitoria',
    'Tel Aviv Yellows': 'Tel Aviv Yellows',
    'Moscow': 'Moscow',
    'Kaunas': 'Kaunas',
    'Barcelona City': 'Barcelona City',
    'Belgrade': 'Belgrade',
    'Lyon': 'Lyon',
    'Khimki': 'Khimki',
    'Berlin': 'Berlin',
    'St Petersburg': 'St Petersburg',
    'Valencia': 'Valencia',
    //Euro 2020 teams
    'Turkey': 'Türkiye',
    'Netherlands': 'Hollanda',
    //Super league
    'Utd': 'United',
    'City': 'City',
    'Liverpool': 'Liverpool',
    'Barcelona': 'Barcelona',
    'Madrid': 'Madrid',
    'Munich': 'Munich',
    'Turin': 'Turin',
    'Milan': 'Milan',
    'Amsterdam': 'Amsterdam',
    'Paris': 'Paris',
    //NFLA
    'Pittsburgh': 'Pittsburgh',
    'Philadelphia': 'Philadelphia',
    'Denver': 'Denver',
    'New York': 'New York',
    'New England': 'New England',
    'Green Bay': 'Green Bay',
    'San Francisco': 'San Francisco',
    'Miami': 'Miami',
    'Dallas': 'Dallas',
    'Oakland': 'Oakland',
    'Chicago': 'Chicago',
    // market specific words
    'DRAW': 'Berab',
    'HD': '{0}/Berab',
    'DA': 'Berab/{1}',
    'HA': '{0}/{1}',
    'Under 2.5': '2.5 Altı',
    'Over 2.5': '2.5 Üstü',
    'Under 1.5': '1.5 Altı',
    'Over 1.5': '1.5 Üstü',
    'Under': '{0} Altı',
    'Over': '{0} Üstü',
    'HOME': '{0}',
    'AWAY': '{1}',
    'Under 0.5': '0.5 Altı',
    'Over 0.5': '0.5 Üstü',
    'Under 3.5': '3.5 Altı',
    'Over 3.5': '3.5 Üstü',
    'Both Score Yes': 'Evet',
    'Both Score No': 'Hayır',
    'Home Not to Score': '{0} Not to Score',
    'Home Exactly 1': '{0} Exactly 1',
    'Home Exactly 2': '{0} Exactly 2',
    'Home Exactly 3': '{0} Exactly 3',
    'Home Exactly 4': '{0} Exactly 4',
    'Away Not to Score': '{1} Not to Score',
    'Away Exactly 1': '{1} Exactly 1',
    'Away Exactly 2': '{1} Exactly 2',
    'Away Exactly 3': '{1} Exactly 3',
    'Away Exactly 4': '{1} Exactly 4',
    'Home to Win and both teams to score': '{0} to Win and both teams to score',
    'Home to Win to nil': '{0} to Win to nil',
    'Score draw': 'Score draw',
    '0-0': '0-0',
    '0-1': '0-1',
    '0-2': '0-2',
    '0-3': '0-3',
    '0-4': '0-4',
    '0-5': '0-5',
    '0-6': '0-6',
    '1-0': '1-0',
    '2-0': '2-0',
    '3-0': '3-0',
    '4-0': '4-0',
    '5-0': '5-0',
    '6-0': '6-0',
    '1-1': '1-1',
    '2-2': '2-2',
    '3-3': '3-3',
    '2-1': '2-1',
    '1-2': '1-2',
    '3-1': '3-1',
    '1-3': '1-3',
    '3-2': '3-2',
    '2-3': '2-3',
    '4-1': '4-1',
    '1-4': '1-4',
    '4-2': '4-2',
    '2-4': '2-4',
    '5-1': '5-1',
    '1-5': '1-5',
    '1-0,2-0,2-1': '1-0,2-0,2-1',
    '3-0,3-1,4-0': '3-0,3-1,4-0',
    '1-1,2-2': '1-1,2-2',
    '0-1,0-2,1-2': '0-1,0-2,1-2',
    '0-3,1-3,0-4': '0-3,1-3,0-4',
    'Away to Win and both teams to score': '{1} to Win and both teams to score',
    'Away to Win to nil': '{1} to Win to nil',
    'Home Win By Exactly 1 Goal': '{0} Win By Exactly 1 Goal',
    'Home Win By Exactly 2 Goals': '{0} Win By Exactly 2 Goals',
    'Home Win By 3 or more goals': '{0} Win By 3 or more goals',
    'Away Win By Exactly 1 Goal': '{1} Win By Exactly 1 Goal',
    'Away Win By Exactly 2 Goals': '{1} Win By Exactly 2 Goals',
    'Away Win By 3 or more goals': '{1} Win By 3 or more goals',
    'Draw With No Goals': 'Draw With No Goals',
    'Draw With Goals': 'Draw With Goals',
    'Any Other': 'Herhangi Diğer',
    'Home Not To Score': '{0} Not To Score',
    'Home To Score': '{0} Gol Atar',
    'Away Not To Score': '{1} Not To Score',
    'Away To Score': '{1} Gol Atar',
    'Home': '{0}',
    'No Goal': 'Gol Yok',
    'Away': '{1}',
    'Home/Home': '{0}/{0}',
    'Home/Draw': '{0}/Berab',
    'Home/Away': '{0}/{1}',
    'Draw/Home': 'Berab/{0}',
    'Draw/Draw': 'Berab/Berab',
    'Draw/Away': 'Berab/{1}',
    'Away/Home': '{1}/{0}',
    'Away/Draw': '{{1}/Berab',
    'Away/Away': '{1}/{1}',
    'Home and 1-0': '{0} and 1-0',
    'Home and 2-0': '{0} and 2-0',
    'Home and 2-1': '{0} and 2-1',
    'Away and 2-1': '{1} and 2-1',
    'Home and 3-0': '{0} and 3-0',
    'Home and 3-1': '{0} and 3-1',
    'Away and 3-1': '{1} and 3-1',
    'Home and 4-0': '{0} and 4-0',
    'Home and 1-1': '{0} and 1-1',
    'Away and 1-1': '{1} and 1-1',
    'Home and 2-2': '{0} and 2-2',
    'Away and 2-2': '{1} and 2-2',
    'Away and 0-1': '{1} and 0-1',
    'Away and 0-2': '{1} and 0-2',
    'Away and 1-2': '{1} and 1-2',
    'Home and 1-2': '{0} and 1-2',
    'Away and 0-3': '{1} and 0-3',
    'Away and 1-3': '{1} and 1-3',
    'Home and 1-3': '{0} and 1-3',
    'Away and 0-4': '{1} and 0-4',
    'Other': 'Diğer',
    'Draw': 'Berab',
    // Basketball
    '120-124': '120-124',
    '125-129': '125-129',
    '130-134': '130-134',
    '135-139': '135-139',
    '140-144': '140-144',
    '145-149': '145-149',
    '150-154': '150-154',
    '155-159': '155-159',
    '160-164': '160-164',
    '165-169': '165-169',
    '170-174': '170-174',
    '175-179': '175-179',
    'Under 180': '180 Altı',
    '180-184': '180-184',
    '185-189': '185-189',
    '190-194': '190-194',
    '195-199': '195-199',
    '200-204': '200-204',
    '205-209': '205-209',
    '210-214': '210-214',
    '215-219': '215-219',
    '220-224': '220-224',
    '225-229': '225-229',
    '230-234': '230-234',
    '235-239': '235-239',
    '240-244': '240-244',
    '245-249': '245-249',
    'Over 249': '249 Üstü',
    //American Football
    '26-30': '26-30',
    '31-35': '31-35',
    '36-40': '36-40',
    '41-45': '41-45',
    '46-50': '46-50',
    '25 And Under': '26 Altı',
    '25 And Under Short': '26 Altı',
    '51 And Over': '50 Üstü',
    '51 And Over Short': '50 Üstü',
    'and': '&',
    'slash': '/',
    // first down
    FIRST_PLAY: '1st Play',
    SECOND_PLAY: '2nd Play',
    THIRD_PLAY: '3rd Play',
    FOURTH_PLAY: '4th Play',
    FIFTH_PLAY: '5th or More Play',
    FIELD_GOAL: 'Field Goal',
    'PassTD on 1st Play': 'PassTD on 1st Play',
    'PassTD on 2nd Play': 'PassTD on 2nd Play',
    'PassTD on 3rd Play': 'PassTD on 3rd Play',
    'PassTD on 4th Play': 'PassTD on 4th Play',
    'PassTD on or after 5th Play': 'PassTD on or after 5th Play',
    'RunTD on 1st Play': 'RunTD on 1st Play',
    'RunTD on 2nd Play': 'RunTD on 2nd Play',
    'RunTD on 3rd Play': 'RunTD on 3rd Play',
    'RunTD on 4th Play': 'RunTD on 4th Play',
    'RunTD on or after 5th Play': 'RunTD on or after 5th Play',
    'Turnover on 1st Play': 'Turnover on 1st Play',
    'Turnover on 2nd Play': 'Turnover on 2nd Play',
    'Turnover on 3rd Play': 'Turnover on 3rd Play',
    'Turnover on 4th Play': 'Turnover on 4th Play',
    'Turnover on or after 5th Play': 'Turnover on or after 5th Play',
    'Field Goal': 'Field Goal',

    //Game Tabs
    'Football': 'Amerikan',
    'Matchday': 'Hafta',
    'Basketball': 'Basketbol',
    'Dogs': 'Köpekler',
    'Motor Racing': 'Araba Yarışları',
    'Results': 'Sonuçlar',
    'Horses': 'Atlar',
    'Soccer': 'Futbol',
    'US Football': 'Amerikan Futbolu',
    'Marble Racing': 'Misket Yarışı',
    "Matchday_English": "İNGİLTERE LİGİ",
    "Matchday_Turkish": "MİSLİ SANAL LİGİ",
    "Matchday_Greek": "Matchday",

    //Game SubTabs
    'Soccer_Euro': 'Avrupa',
    'Soccer_Soccer3_Super_League': 'Süper Lig',
    'Soccer_Soccer3_Greek_League': 'Greek Lig',
    'Soccer_Super_League': 'Süper Lig',
    'Soccer_World_Cup': 'Dünya Kupası',
    'Soccer_Soccer3_World_Cup': 'Dünya Kupası',
    'Horses_Sprints': 'Depar Yarışları',
    'Horses_Flats': 'Düz Koşular',
    'Horses_Jumps': 'Zıplama Yarışları',
    'Basketball_US1': 'ABD',
    'Basketball_US2': 'ABD',
    'Basketball_Europe': 'Avrupa',
    'Dogs_Flats': 'Düz Koşular',
    'Dogs_City': 'Static Odds',
    'Motor_Racing_Stock_Cars': 'Stok Arabalar',
    'Motor_Racing_Indy_Cars': 'Indy Arabalar',
    'US_Football_NFLA': 'NFLA',
    'US_Football_NFL': 'NFL',
    'US_Football_Football': 'Amerikan',
    'Marble_Racing_Marbles': 'Misketler',
    'Marble_Racing_Marbles2': 'Kum',
    'Marble_Racing_Marbles_Euro': 'Euro Misket',
    'Marble_Racing_Marbles_Halloween': 'Halloween',
    "Matchday_English_Matchday_English": "İNGİLTERE LİGİ",
    "Matchday_Turkish_Matchday_Turkish": "MİSLİ SANAL LİGİ",
    "Matchday_Greek_Matchday_Greek": "Matchday",

    //Racing
    FORECAST: 'İkili Sıralı',
    TRICAST: 'Üçlü Sıralı',
    REVERSE_FORECAST: 'Kombinasyon İkili Sıralı',
    REVERSE_TRICAST: 'Üçlü Sıralı Kombinasyon',
    FIRST_ST: '1.',
    SECOND_ND: '2.',
    THIRD_RD: '3.',
    RD: ' ',
    ST: ' ',
    ND: ' ',
    ANY: 'Herhangi',
    TO_WIN: 'Kazanan',
    RACE_CARD: 'yarış programı',
    EACH_WAY: 'Each Way',
    EW: 'E/W',
    FORECAST_TRICAST: 'İkili/Üçlü Sıralı',
    EACH_WAY_ODDS_PLACE: 'E/W {0} 1-2',
    EACH_WAY_ODDS_SHOW: 'E/W {0} 1-2-3',
    EXPAND_ALL: 'Bahis Türlerini Genişlet',
    COLLAPSE_ALL: 'Bahis Türlerini Küçült',
    NUMBER: 'Numara',
    SORT_BY: 'Sırala',
    BET_SLIP: 'Kuponum',
    CLOSE_BET_SLIP: 'Kapat',
    CLOSE_SLIP: 'Kapat',
    PLACED_BETS: 'Onaylananlar',
    SETTLED_BETS: 'Biten',
    SLIP: 'Kupon',
    OPEN_BETS: 'Açık',
    CLEAR_SELECTIONS: 'Seçimleri Sil',
    ADD_TO_BET_SLIP: 'Kupona Ekle',
    NO_BETS: 'Kuponunuzda seçim bulunmamaktadır',
    COMBINATION_TRICAST: 'Üçlü Sıralı Kombinasyon',
    COMBINATION_FORECAST: 'Kombinasyon Tahmin',
    TOTAL_STAKE: 'Toplam Kupon Tutarı',
    TOTAL_POTENTIAL_RETURNS: 'Toplam Muhtemel Kazanç',
    N_A: 'Yok',
    PLACE_BETS: 'Hemen Oyna',
    REMOVE_ALL: 'Hepsini Sil',
    POT_RETURNS: 'Muhtemel Kazanç:',
    RETURNED: 'Kazanç:',
    REFUNDED: 'Ödenen',
    OK: 'Tamam',
    WIN_INITIAL: 'G',
    DRAW_INITIAL: 'D',
    LOSE_INITIAL: 'M',

    //Settings
    SETTINGS: 'Ayarlar',
    LANGUAGE: 'Dil',
    LAYOUT: 'Tema',
    ODDS: 'Oran',
    EN_GB: 'English UK',
    DECIMAL: 'Ondalık',
    FRACTIONAL: 'Kesirli',
    AMERICAN: 'Amerikan',
    SIMPLIFIED_DESKTOP: 'This is The main class for the desktop simplified UI',
    SIMPLIFIED_MOBILE: 'This is The main class for the mobile simplified UI',
    SHOW_VIDEO: 'Show Video',

    //Notifications
    ALERT_NOTIFICATION: 'Uyarı',
    WARNING_NOTIFICATION: 'Dikkat',
    WARNING_NOTIFICATION_REALITY_CHECK: 'Bilgilendirme',
    INFO_NOTIFICATION: 'BİLGİ',
    SUCCESS_NOTIFICATION: 'Başarılı',

    SELECTION_REMOVAL: 'Bu seçim ',
    SECONDS: ' saniye içerisinde silinecek',
    SECOND: ' saniye içerisinde silinecek',
    REMOVE_CLOSED_EVENTS: 'Kapanan Etkinlikleri Sil',
    SET_VIDEO_ON_FUL_SCREEN: 'Video Tam Ekran Olsun mu??',
    CANCEL: 'İptal',

    //Error codes
    INTERNAL_ERROR: 'Dahili Hata',
    OPEN_BETS_WARNING: 'Açık bahislerin bazıları veya tümü, geçmişteki etkinliklere ait oldukları için oyun kartına eklenemedi.',
    '-32602': 'Bir veya daha fazla bahis zamanında onaylanmadı.',
    OPEN_BETS_ON_BET_SLIP_LIMIT_REACHED: 'Kupona ait maksimum bahis sayısına ulaşıldı. Yeni bahis eklemek için lütfen kuponunuzdaki bahisleri siliniz veya onaylayınız.',

    '-20000': 'Cannot establish connection (Error Code: -20000)', //INIT_NOT_INVOKED
    '-20001': 'Cannot establish connection (Error Code: -20001)', //MISSING_SESSION_TOKEN
    '-20002': 'Too many requests (Error Code: -20002)', //Duplicate single shot invocation
    '-20003': 'Too many requests (Error Code: -20003)', //INVOCATION_FREQUENCY_THRESHOLD_BREACHED
    '-20004': 'Invalid Request (Error Code: -20004)', //A BmsServerAPI command was received, but the params are not compliant with Operator rules.
    '-10000': 'Invalid Request (Error Code: -10000)', //INVALID_SESSION_TOKEN
    '-10001': 'Invalid Request (Error Code: -10001)', //INBOUND_MESSAGE_QUEUE_FULL
    '-1000': 'Oyun askıya alındı. Lütfen müşteri hizmetleriyle iletişime geçiniz.',
    '-999': 'Oturum süresi doldu.',
    '-998': 'Oyuncu Askıya Alındı',
    '-997': 'Komuta izin verilmiyor',
    '-996': 'Error processing request (Error Code: -996)', //Gaming System Error
    '-995': 'Error processing request (Error Code: -995)', //BMS Internal Error
    '-994': 'Sunucu ile bağlantı kesildi, bahis onaylanmadı.',
    '-980': 'Error processing request (Error Code: -980)', //Error processing game command.
    '-979': 'Error processing request (Error Code: -979)', //Error on Json message sent by Virgo.
    '-978': 'Bu işlemi gerçekleştirmek için yeterli bakiye bulunmamaktadır.',
    '-977': 'Gerçeklik kontrolü başarısız oldu.',
    '-976': 'Cüzdan işlemi geçici olarak engellendi.',
    '-975': 'Bahis sınırı aşıldı.',
    '-974': 'Kayıp sınırı aşıldı.',
    '-973': 'Sınır belirlenmemiş.',
    '-972': 'Sorumlu bahis hatası.',
    '-971': 'Cüzdan işlemi başarısız oldu.',
    '-970': 'Cüzdan işlemi reddedildi.',
    '-969': 'Cüzdan iletişim hatası.',
    '-968': 'Cüzdan işlem hatası.',
    '-967': 'Kimlik doğrulama başarısız.',
    '-966': 'Yüksek kazanç eşiği aşıldı.',
    '-965': 'Geçersiz parametreler sunuldu.',

    // BET LIMITS ALERTS
    BET_STAKE_OUT_OF_LIMITS_MESSAGE: 'Kupon tutarı minimum {0}, maksimum {1} olmak zorundadır. Lütfen kuponunuzu kontrol ediniz.',
    LIST_BET_STAKE_OUT_OF_LIMITS_MESSAGE: 'Stake limits on {0} are Min {1} & Max {2}',
    BET_POTENTIAL_RETURNS_OUT_OF_LIMITS_MESSAGE: 'Bir veya daha fazla bahsin muhtemel getirisi, {0} olan maksimum ödeme sınırını aşıyor. Bahislerinizi onaylamadan önce lütfen kuponunuzu düzenleyiniz.',
    BET_NON_DIVISIBLE_MESSAGE: 'One or more bets not divisible by {0} . Please fix this before placing your bets.',
    SINGLE_BET_COMMIT_MESSAGE: 'You cannot place multiple single bets',
    REALITY_CHECK_WARNING_MESSAGE_LINE_1: 'Kuponunuz ile {0} ve üzeri bir oyun oynamak üzeresiniz.',
    MIN_STAKE_REALITY_CHECK_WARNING_MESSAGE_LINE_1: 'The bet(s) you are placing are under {0}',
    REALITY_CHECK_WARNING_MESSAGE_LINE_2: 'Onaylıyor musunuz?',
    REALITY_CHECK_TOTAL_STAKE_SINGLE_EVENT_WARNING: 'Tek bir etkinlik için maksimum {0} ’lik kupon yapabilirsiniz. Lütfen kuponunuzu kontrol ediniz',

    //SIMPLIFIED UI
    TOTAL_BETS: 'TOTAL BET:',
    PLACE_YOUR_BETS: 'Hemen Oyna',
    RACE_START: 'Yarış Başlangıcı',
    RACE_START_TIME: 'Başlangıç Saati',
    BET_SUMMARY: 'Kupon Özeti',
    NO_BETS_RESUME: 'Mevcut etkinlik için bahis yapılmadı',
    LIVE: 'CANLI',
    RACERS: 'Yarışçılar',
    SELECTION: 'Seçim',
    DATE_LOCATION: 'Etkinlik',
    STAKE: 'Tutar',
    BET_TYPE_STAKE: 'Seçim Türü/Tutar',
    POTENTIAL_RETURNS: 'Muhtemel Kazanç',
    BET_HISTORY: 'Kupon Geçmişi',
    BET_HISTORY_LABEL: 'Daha fazlasını görmek için Bahis Geçmişi butonuna tıklayınız.',
    FILTER_WINS: 'Kazananlar',
    NEXT_RACE: 'Sonraki Yarış',
    WIN: '1.',
    PLACE: 'ilk 2',
    SHOW: 'ilk 3',
    EXACTA: 'Tahmin',
    TRIFECTA: 'Üçlü Sıralı',
    NO_WIN: 'KAZANÇ YOK',
    WON: 'KAZANDI',
    LOST: 'KAYBETTİ',
    CURRENT_RACE: 'Mevcut Yarış',
    BOX: 'KUTU',
    TO: 'to',
    PAYS: 'öder',
    TRIFECTA_BOX: 'Üçlü Sıralı Kombinasyon',
    EXACTA_BOX: 'Kombinasyon Tahmin',
    FINISH_YOUR_BETS: 'Bahislerini bitir',
    SELECT_YOUR_BET_BELOW: 'Aşağıdan Seçiminizi Yapınız',
    BET: 'bahis',
    REMOVED: 'silindi',
    RESULT: 'Sonuç',
    GOALS: 'Goller',
    NO_MORE_BETS: 'Etkinlik Kapanmıştır',
    EVENT_LIVE: 'Etkinlik Başlamıştır.',
    EVENT_LIVE_MSG_LINE_1: 'Etkinlik Başlamıştır.',
    EVENT_LIVE_MSG_LINE_2: ' ',
    EVENT_LIVE_MSG_LINE_3: ' ',
    NO_FUTURE_EVENTS: 'Gelecekte Etkinlik Yok',
    AUTHENTICATION_REQUIRED: 'Devam Etmek İçin Lütfen Üye Giriş Yapınız',
    GAME_DISABLED: 'Oyun Devre Dışı',
    GAME_DISABLED_MESSAGE: 'Lütfen müşteri hizmetleriyle iletişime geçiniz.',
    VOIDED: 'GEÇERSİZ',
    HELP: 'Yardım',
    LAST_RESULTS: 'Son Sonuçlar',
    NO_LAST_RESULTS: 'Son Sonuçlar Yok',
    PREVIOUS_RESULTS: 'Önceki Sonuçlar',
    OFFENSE_PREVIOUS_RESULTS: 'Offence Previous Results',
    DEFENSE_PREVIOUS_RESULTS: 'Defence Previous Results',
    NO_LUCK: 'NO LUCK',
    THIS_TIME: 'THIS TIME',
    LOOK_FOR_THE_NEXT: 'Sıradaki',
    SCHEDULED_EVENT: 'Planlı Etkinlik',
    LOOK_FOR_THE: 'Sıradaki',
    NEXT_SCHEDULED: 'Planlı',
    EVENT: 'Etkinlik',
    RETURNS: 'KAZANÇ',
    NEXT: 'Sıradaki',
    FUTURE: 'Bir Sonraki',
    PLAYING: 'Oynanıyor',

    //MESSAGE BAR
    ON: 'üzerinde',
    MB_RACE_ON: 'üzerinde',
    MB_RACE_WIN: 'Kazanan',
    MB_RACE_PLACE: 'sıraya',
    MB_RACE_SHOW: 'göstermek için',
    MB_RACE_TRIFECTA_BOX: 'Üçlü Sıralı Kombinasyon',
    MB_RACE_EXACTA_BOX: 'Kombinasyon Tahmin',
    MB_RACE_EXACTA: 'Tahmin',
    MB_RACE_TRIFECTA: 'Üçlü Sıralı',
    MB_FOOTBALL_ON: 'üzerinde',

    // DESKTOP UI
    ADVERTISING_SPACE: 'REKLAM ALANI',
    CLEAR_LAST: 'Sonuncuyu Temizle',
    CLEAR_ALL: 'Hepsini Temizle',
    ACTIVE_BETS: 'Etkin Bahisler',
    ONLY_SHOW_WINS: 'Sadece kazananları göster',
    MORE: 'Daha Çok',
    BETS: 'Bahis',
    LOADING: 'Yükleniyor',
    BET_SELECTION_MESSAGE: 'Oranlara tıklayarak seçimlerinizi yapabilirsiniz.',

    // BUTTONS
    SIMPLE: 'simple',
    EXOTIC: 'exotic',
    UNDO: 'geri al',
    CLEAR: 'temizle',
    HISTORY: 'geçmiş',

    MARKETS: 'Türler',
    MAIN: 'Ana',
    VS: 'vs',
    AT: '@',
    SCORE: 'skor',
    DEFENDS: '(Defends) at',
    ATTACKS: '(Attacks) at',
    DETAILS: 'Detaylar',
    NO_GOALS: 'Gol yok',

    MAX_WINNINGS_REACHED: 'Maks. Kazanca Ulaşıldı',
    MAX_WINNINGS_REACHED_TEXT: 'The current bet will exceed the max payout of {0}. Max Stake value permitted for this bet is {1}.',
    NO_CONNECTION_TITLE: 'Bağlantı Koptu',

    NO_CONNECTION_TITLE_TEXT: 'Sunucu ile bağlantı kesildi, lütfen stabil bir ağa bağlandığından emin olunuz ve sayfayı yenileyiniz. Sorun devam ederse destek ekibiyle iletişime geçiniz.',
    PLAYER_LOGGED_OTHER_PLACE_TITLE_TEXT: 'Bağlantı kapatıldı, kullanıcı iki kez bağlandı.',
    BET_CONFIRMED_TEXT:'kuponunuz oynandı.',
    TAX_NOTIFICATION_TEXT: 'none',
    //Event title names
    //Football
    'THE MANOR GROUND': 'Berners Stadium',
    'METRO STADIUM': 'Metro Stadium',

    //Horses Sprints
    'HorsesSprints': 'Wetmore Sprints',
    'Showell Park': 'Showell Park',
    '2FurlongHorses': 'Wetmore Sprints',
    'Sandringham Flats': 'Sandringham Flats',
    'Princess Parkway': 'Princess Parkway',

    //BasketBall
    'Virtual Arena': 'Virtual Arena',
    'Inspired Arena': 'Inspired Arena',
    //Horses Jumps
    'HorsesJumps': 'Inspired Downs',

    //Dogs
    'DogFlat': 'Barking Green',
    'Dogs2': 'Barking Green',
    'Victoria Park': 'Victoria Park',
    'Jennison Stadium': 'Jennison Stadium',

    //Motor Racing
    'Circuit': 'Circuit',

    //Speedway Park
    'Speedway Park': 'Inspired Raceway',
    'Auto Raceway': 'Auto Raceway',

    'NO_CONNECTION_TO_VIRGO': 'Bağlantı koptu',
    'NO_CONNECTION_TO_VIRGO_TEXT': 'Lütfen sayfayı yenileyiniz ve üye giriş yapınız.',
    'BROWSER_NOT_SUPPORTED_DETAILS': 'Your current browser is not supported. Please use one of the following browsers: Chrome, Firefox or Safari.',
    'BROWSER_NOT_SUPPORTED': 'Tarayıcı Desteklenmiyor',
    'DOWNLOAD_CHROME': 'Chrome\'u indir',
    'DOWNLOAD_FIREFOX': 'Firefox\'u indir',
    'v': 'V',
    '1': '1',
    'x': 'x',
    '2': '2',
    'at': '@',
    '+10.5': '+10.5',
    '+15.5': '+15.5',
    '+5.5': '+5.5',
    '-10.5': '-10.5',
    '-15.5': '-15.5',
    '-5.5': '-5.5',
    'Over 219.5': '219,5 Üstü',
    'Under 219.5': '219,5 Altı',
    'Over 214.5': 'Üstü 214,5',
    'Under 214.5': 'Altı 214,5',
    'Over 209.5': 'Üstü 209,5',
    'Under 209.5': 'Altı 209,5',
    'Over 144.5': 'Üstü 144,5',
    'Under 144.5': 'Altı 144,5',
    'Over 149.5': 'Üstü 149,5',
    'Under 149.5': 'Altı 149,5',
    'Over 154.5': 'Üstü 154,5',
    'Under 154.5': 'Altı 154,5',
    'Over 159.5': 'Üstü 159,5',
    'Under 159.5': 'Altı 159,5',
    'Over 164.5': 'Üstü 164,5',
    'Under 164.5': 'Altı 164,5',
    'Rolling Downs': 'Rolling Downs',
    'FINISHING_ORDER': 'İkili/Üçlü Sıralı',
    'FORECAST_MARBLE': 'İkili Sıralı',
    'TRICAST_MARBLE': 'Üçlü Sıralı',
    'REVERSE_FORECAST_MARBLE': 'Kombinasyon İkili Sıralı',
    'REVERSE_TRICAST_MARBLE': 'Üçlü Sıralı Kombinasyon',
    'TO_WIN_MARBLE': '1.',
    'PLACE_MARBLE': 'ilk 2',
    'SHOW_MARBLE': 'ilk 3',
    'MARBLE': 'Misket',
    'Rumble Turns': 'Rumble Turns',
    'Maple Downs': 'Maple Downs',

    //Header
    'BALANCE': 'Bakiye',
    'DATE_FORMAT': 'DD/MM/YYYY HH:mm',
    'WINS_THE_GAME': 'Oyunu Kazanıyor',
    'Any': 'veya',
    "BET_BOTH": "ikisi de",
    //Matchday
    "betSlip_Matchday_English": "İNGİLTERE LİGİ",
    "betSlip_Matchday_Turkish": "MİSLİ SANAL LİGİ",
    "betSlip_Matchday_Greek": "Matchday Greek",
    "betSlip_Soccer": "Futbol",
    "betSlip_Horses": "Atlar",
    "betSlip_Basketball": "Basketbol",
    "betSlip_Dogs": "Köpekler",
    "betSlip_Motor Racing": "Araba Yarışları",
    "betSlip_US Football": "Amerikan Futbolu",
    "betSlip_Marble Racing": "Misket Yarışı",
    "POS": "#",
    "TEAM": "TAKIM",
    "P": "O",
    "W": "G",
    "D": "B",
    "L": "M",
    "F": "AG",
    "A": "YG",
    "PTS": "PU",
    "LEAGUE TABLE": "Puan Durumu",
    "TREND": "Form",

    //Matchday English Teams
    "Matchday_Islington": "ISL",
    "Matchday_City": "CTY",
    "Matchday_Palace": "PAL",
    "Matchday_Chelsea": "CHE",
    "Matchday_Southampton": "SOU",
    "Matchday_Wolverhampton": "WOL",
    "Matchday_Sheffield": "SHE",
    "Matchday_Leicester": "LEI",
    "Matchday_Newcastle": "NEW",
    "Matchday_Tottenham": "TOT",
    "Matchday_West Ham": "WHA",
    "Matchday_United": "UTD",
    "Matchday_Leeds": "LEE",
    "Matchday_Liverpool": "LIV",
    "Matchday_Everton": "EVE",
    "Matchday_Aston": "AST",

    //Matchday Turkish Teams
    "Matchday_Basaksehir": "BAS",
    "Matchday_Trabzon": "TRZ",
    "Matchday_Besiktas": "BKS",
    "Matchday_Sivas": "SIV",
    "Matchday_Alanya": "ALA",
    "Matchday_Galata": "GLS",
    "Matchday_Fenerbahce": "FRB",
    "Matchday_Gazientep": "GAZ",
    "Matchday_Antalya": "ANT",
    "Matchday_Kasimpasa": "KAS",
    "Matchday_Goztepe": "GOZ",
    "Matchday_Gencler": "ESK",
    "Matchday_Konya": "BUR",
    "Matchday_Rize": "RIZ",
    "Matchday_Malatya": "MAL",
    "Matchday_Kayseri": "KAY",

    //Matchday Greek Teams
    "Matchday_Dikefalos Vora": "ΔΙΚ",
    "Matchday_Erithrolefkoi": "ΘΡΥ",
    "Matchday_Enosi": "ΕΝΩ",
    "Matchday_Peristeri": "ΠΕΡ",
    "Matchday_Prasinoi": "ΠΡΑ",
    "Matchday_Kitrinoi Vora": "ΚΙΤ",
    "Matchday_Nea Smirni": "ΣΜΥ",
    "Matchday_Xanthi": "ΞΑΝ",
    "Matchday_Tripoli": "ΤΡΙ",
    "Matchday_Agrinio": "ΑΓΡ",
    "Matchday_Larisa": "ΛΑΡ",
    "Matchday_Lamia": "ΛΑΜ",
    "Matchday_Ioannina": "ΙΩΑ",
    "Matchday_Iraklio": "ΗΡΑ",
    "Matchday_A.O. Rizoupolis": "ΡΙΖ",
    "Matchday_Volos": "ΒΟΛ",

//Soccer3 Greek Teams
    "Dikefalos Vora": "ΔΙΚ",
    "Erithrolefkoi": "ΘΡΥ",
    "Enosi": "ΕΝΩ",
    "Peristeri": "ΠΕΡ",
    "Prasinoi": "ΠΡΑ",
    "Kitrinoi Vora": "ΚΙΤ",
    "Nea Smirni": "ΣΜΥ",
    "Xanthi": "ΞΑΝ",
    "Tripoli": "ΤΡΙ",
    "Agrinio": "ΑΓΡ",
    "Larisa": "ΛΑΡ",
    "Lamia": "ΛΑΜ",
    "Ioannina": "ΙΩΑ",
    "Iraklio": "ΗΡΑ",
    "A.O. Rizoupolis": "ΡΙΖ",
    "Volos": "ΒΟΛ",

    "Dortmund": "Dortmund",
    "Chelsea": "Chelsea",
    "Porto": "Porto",
    "Rome": "Rome",
    "Benfica": "Benfica",
    "Celtic": "Celtic",
    "United": "United",
    UNDER_OVER_MATCHDAY: 'Üst/Alt',
    UNDER_OVER_05_SHORT: "0.5",
    UNDER_OVER_25_SHORT: "2.5",
    UNDER_OVER_35_SHORT: "3.5",
    UNDER_OVER_15_SHORT: "1.5",
    UNDER_SHORT: "A",
    OVER_SHORT: "Ü",

    "FULL TIME": "Maç Sonu",
    "FT": "MS",
    "System": "SISTEM",
    "x1": "(x1)",
    "Multiplier": "Kupon Adedi",
    "Main markets": "FAVORİ MARKETLER",
    "4RANDOM": "4 RASTGELE",
    "6RANDOM": "6 RASTGELE",
    "8RANDOM": "8 RASTGELE",
    "8FAVS": "8 FAVORİ",
    "QUICK_SELECT": "Hızlı Seçim",
    "UNDER": "ALT",
    "OVER": "ÜST",
    "UNDER_OVER_2_5": "2.5 Üst/Alt",
    "UNDER_OVER_3_5": "3.5 Üst/Alt",
    "MATCH_RESULT": "Maç Sonucu",
    "YES": "EVET",
    "NO": "HAYIR",
    "REALITY_CHECK_WARNING_YES": "Onayla",
    "REALITY_CHECK_WARNING_NO": "Vazgeç",
    "ACCUMULATOR": "Kombine",
    "+1G": "+1H",
    "Single": "Tekli",
    "Doubles": "İkili",
    "Trebles": "Üçlü",
    "Four Folds": "4 Kombine",
    "Five Folds": "5 Kombine",
    "Six Folds": "6 Kombine",
    "Seven Folds": "7 Kombine",
    "Eight Folds": "8 Kombine",
    "MD": "{0}.H",
    "MATCH": "MAÇ",
    "INVALID_ACCA": "Belirtilen seçimlerde çoklu seçim yapılamaz",
    "INVALID_ODDS": "Oran değeri çok yüksek. Lütfen seçimlerinizi değiştirin",
    "INVALID_ACCA_MORETHAN_8": "Aynı etkinlik için en fazla 8 adet bahis seçimi yapabilirsiniz.",

    // Accumulator Boost
    "ACCUMULATOR_BOOST": 'Kombine Bonusu',
    "Bonus_Info": " %{0} Bonus",
    "+": "+",
    "Bonus_Value": "Ek Kazanç {0} Bonus",
    "ACCUMULATOR_INFO": 'Kombine kuponunuz kazandığı takdirde, %{0} - %{1} arasında bonus miktarı kazancınıza eklenecektir. Bonus miktarı, kuponunuzda bulunan etkinlik sayısına bağlı olarak değişmektedir.',
    "BET_TYPE": 'Tahmin Türü',
    "BOOST": '	Bonus',
    "BOOST_PERCENTAGE": '%{0}',
    "BOOST_BONUS_START": '{0} veya daha fazla maç seçiminde kazancınıza bonus eklenecektir.',
    "BOOST_BONUS_UPGRADE": 'Daha fazla bonus kazanmak için kuponunuza 1 maç daha ekleyiniz.',
    "BOOST_BONUS_MAX": 'Maksimum bonusa sahipsiniz.',
    "Marbles_Euro_1": "Belçika",
    "Marbles_Euro_2": "Hırvatistan",
    "Marbles_Euro_3": "Danimarka",
    "Marbles_Euro_4": "İngiltere",
    "Marbles_Euro_5": "Fransa",
    "Marbles_Euro_6": "Almanya",
    "Marbles_Euro_7": "İtalya",
    "Marbles_Euro_8": "Hollanda",
    "Marbles_Euro_9": "Portekiz",
    "Marbles_Euro_10": "İspanya",
    "Short_Over": "{0} Üstü",
    "Short_Under": "{0} Altı",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_1": "Please register or log in to place a bet",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_2": " ",
    "DEMOPLAY_NOTIFICATION_DISMISS": "Dismiss",
    "DEMOPLAY_NOTIFICATION_OK": "OK",
    "Matchday_Moroccan": "Journée",
    "Matchday_Moroccan_Matchday_Moroccan": "Journée",
    "betSlip_Matchday_Moroccan": "Journée",

    //Matchday Moroccan Teams
    "Matchday_Casa Reds": "WYD",
    "Matchday_Casa Greens": "RAJ",
    "Matchday_Fès": "FES",
    "Matchday_El Jadida": "ELJ",
    "Matchday_Berkane": "BKN",
    "Matchday_Feth": "FTH",
    "Matchday_FARabat": "FAR",
    "Matchday_Mohammedia": "MOH",
    "Matchday_Soualem": "SLM",
    "Matchday_Khouribga": "KHO",
    "Matchday_Tanger": "TAN",
    "Matchday_Agadir": "AGA",
    "Matchday_Berrechid": "BER",
    "Matchday_Oujda": "OUJ",
    "Matchday_Safi": "SAF",
    "Matchday_Oued Zem": "ODZ",
    "Matchday_Tétouan": "TET",
    "Matchday_Touarga": "TRG",
    "Matchday_Beni Mellal": "BNM",
    "Matchday_Stade Maroc": "STM",
    "Matchday_Zemamra": "ZMR",

    "Soccer_Soccer3_Moroccan_League": "Moroccan",
    //Soccer3 Moroccan Teams
    "Casa Reds": "Casa Reds",
    "Casa Greens": "Casa Greens",
    "Fès": "Fès",
    "El Jadida": "El Jadida",
    "Berkane": "Berkane",
    "Feth": "Feth",
    "FARabat": "FARabat",
    "Mohammedia": "Mohammedia",
    "Soualem": "Soualem",
    "Khouribga": "Khouribga",
    "Tanger": "Tanger",
    "Agadir": "Agadir",
    "Berrechid": "Berrechid",
    "Oujda": "Oujda",
    "Safi": "Safi",
    "Oued Zem": "Oued Zem",
    "Tétouan": "Tétouan",
    "Touarga": "Touarga",
    "Beni Mellal": "Beni Mellal",
    "Stade Maroc": "Stade Maroc",
    "Zemamra": "Zemamra",
    "QUICK_FILL": "Quick Fill",
    "MAD" : "{0} MAD",

    //Matchday Belgium
    "Matchday_Belgium": "Matchday",
    "Matchday_Belgium_Matchday_Belgium": "Matchday",
    "betSlip_Matchday_Belgium": "Matchday Belgium",
    //Matchday Belgium Teams
    "Matchday_Saint-Gilles": "SAI",
    "Matchday_Club": "CLU",
    "Matchday_Anderlecht": "AND",
    "Matchday_Antwerp": "ANT",
    "Matchday_Gent": "GEN",
    "Matchday_Mechelen": "MEC",
    "Matchday_Charleroi": "CHA",
    "Matchday_Genk": "GNK",
    "Matchday_Brugge": "BRU",
    "Matchday_Sint-Truiden": "SIN",
    "Matchday_Leuven": "LEU",
    "Matchday_Kortrijk": "KOR",
    "Matchday_Liege": "LIE",
    "Matchday_Oostende": "OOS",
    "Matchday_Waregem": "WAR",
    "Matchday_Eupen": "EUP",
    "Matchday_Seraing": "SER",

    //BonusBet
    "Gift_for_You_Heading" :"BİR HEDİYEN VAR",
    "Gift_for_You_Content": "Tebrikler! Faydalanabileceğin promosyon teklifleri var.",
    "View_Offers" : "TEKLİFLERİ GÖRÜNTÜLER",
    "Do_Not_Show_MSG": "TEKRAR GÖSTERME",
    "MY_OFFERS": "TEKLİFLERİM",
    "SELECT_OFFER":	"TEKLİFİNİ SEÇ",
    "NO_OFFER" : "AKTİF TEKLİF YOK",
    "CHOOSE_BET": "BAHİS SEÇ",
    "Opt_In": "KATIL",
    "Key_Terms_Heading" :"ANA ŞARTLAR",
    "No_Thanks" : "HAYIR, TEŞEKKÜRLER",
    "PROMO_BET": "PROMOSYON BAHSİ",
    "Time_To_Bet": "BAHİS ZAMANI",
    "OPTED_IN_MSG": "KATILDIĞIN İÇİN TEŞEKKÜRLER",
    "EXP": "Ör.",
    "SELECT": "SEÇ",
    "Horses_US_Horses": "USA",

    //cricket
    "Cricket" : "Kriket",
    "Cricket_International": "Uluslararası",
    "betSlip_Cricket": "Kriket",
    //circket teams
     "Australia":"Australia",
     "India":"India",
     "Pakistan":"Pakistan",
     "West Indies" : "West Indies",
     "Sri Lanka":"Sri Lanka",
     "New Zealand":"New Zealand",
     "South Africa":"South Africa",
     "Australia_short":"AUS",
     "WestIndies_short" : "WI",
     "SriLanka_short":"SRI",
     "NewZealand_short":"NZL",
     "India_short":"IND",
     "SouthAfrica_short":"RSA",
     "Pakistan_short":"PAK",
     "England_short": "ENG",
     "Tie":"Tie",
    //cricket markets
     "MATCH_WINNER":"Maç Kazananı",
     "TOTAL_SIXES_IN_MATCH":"Toplam Maç 6'ları",
     "TOTAL_SIXES_IN_MATCH_SHORT": "Under 1.5",
     "TOTAL_FOUR_IN_MATCH":"Toplam Maç 4'leri",
     "TOTAL_BOUNDARIES_IN_MATCH":"Toplam Maç Sınırları",
     "FIRST_TEAM_TOTAL_RUNS":"{0} Toplam Koşular",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL":"{0} İlk Göndermeyle Başlayan Koşular",
     "FIRST_TEAM_WICKET_LOST":"{0} Wicket Kaybedildi",
     "FIRST_TEAM_WICKET_LOST_DISMISSAL_TYPE": "{0} İlk Çıkma Türü Yöntemi",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05_SHORT": "0.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15_SHORT": "1.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25_SHORT": "2.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35_SHORT": "3.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_UNDER_OVER":"{0} İlk Topla Başlayan Koşular Üst/Alt (O/U)",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05": "{0} İlk Topla Başlayan Koşular Üst/Alt",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15": "{0} İlk Topla Başlayan Koşular Üst/Alt",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25": "{0} İlk Topla Başlayan Koşular Üst/Alt",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35": "{0} İlk Topla Başlayan Koşular Üst/Alt",
     "Caught" : "Yakalandı",
     "Bowled":"Top Atıldı",
     "LBW":"LBW",
     "No Wicket":"Wicket Yok",
     "OverZeroPointFive": "Üstü 0.5",
     "UnderZeroPointFive": "Altı 0.5",
     "OverOnePointFive": "Üstü 1.5",
     "UnderOnePointFive": "Altı 1.5",
     "OverTwoPointFive": "Üstü 2.5",
     "UnderTwoPointFive": "Altı 2.5",
     "OverThreePointFive": "Üstü 3.5",
     "UnderThreePointFive": "Altı 3.5",
     "Yes": "EVET",
     "No":"HAYIR",
     "FINAL_SCORE":"Final Score",
     OVER_145: 'Üstü 14.5',
     UNDER_145: 'Altı 14.5',
     DRAW_Cricket: "DRAW",
     //TENNIS
     TOTAL_POINTS:"Toplam Puan",
     HANDICAP_TENNIS: "Handicap",
     Scotland :"Scotland",
     USA: "USA",
     Tennis_International: "Uluslararası",
     betSlip_Tennis: "Tenis",
     "Win By 2 or 3": "3 Puan veya Daha Az Farkla Galibiyet",
     "Win By 4 or 5": "4 veya 5 Puan Farkla Galibiyet",
     "Win By 6 or 7": "6 veya 7 Puan Farkla Galibiyet",
     "Tennis": "Tenis",
    //baseball
     WINNER : "KAZANAN",
     TOTAL_HOME_RUNS_UNDER_OVER: "TOPLAM SAYI TURU A/Ü",
     TOTAL_HOME_RUNS:  "TOPLAM TAM SAYI TURU",
     WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER:"KAZANAN VE TOPLAM SAYI TURU 5,5 A/Ü",
     WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER_SHORT:"Kazanan ve Toplam Sayı Turu 5,5 A/Ü",
     BATTER1_HOME_RUNS: "{0} SAYI TURU",
     BATTER2_HOME_RUNS: "{1} SAYI TURU",
     Baseball_HR_ShootOut_Legends: "Sayı Turu Vuruşu Efsaneleri",
     Baseball_HR_ShootOut_Legends_SHORT: "Sayı Turu Vuruşları",
     "Baseball": "Beyzbol",
     "betSlip_Baseball": "Beyzbol",
     "Player 1 AND OVER_5_5":"{0} ve 5,5 Üst",
     "Player 2 AND OVER_5_5":"{0} ve 5,5 Üst",
     "Player 1 AND UNDER_5_5":"{0} ve 5,5 Alt",
     "Player 2 AND UNDER_5_5":"{0} ve 5,5 Alt",
     "Draw AND OVER_5_5":"Beraberlik ve 5,5 Üst",
     "Draw AND UNDER_5_5":"Beraberlik ve 5,5 Alt",
     "HOME RUNS":"{0} SAYI TURU",
     "Next Fixtures":"Next Fixtures",
     "MATCH_IN_PROGRESS": "Match In Progress",
     "Matchday_Light_English": "Matchday Light",
     "Matchday_Light_English_Matchday_Light_English": "English League",
     "betSlip_Matchday_Light_English": "Matchday Light",
     //NFL
    'Cardinals' : 'Cardinals',
    'Falcons' : 'Falcons',
    'Ravens' : 'Ravens',
    'Bills' : 'Bills',
    'Panthers' : 'Panthers',
    'Bears' : 'Bears',
    'Bengals' : 'Bengals',
    'Browns' : 'Browns',
    'Cowboys' : 'Cowboys',
    'Broncos' : 'Broncos',
    'Lions' : 'Lions',
    'Packers' : 'Packers',
    'Texans' : 'Texans',
    'Colts' : 'Colts',
    'Jaguars' : 'Jaguars',
    'Chiefs' : 'Chiefs',
    'Raiders' : 'Raiders',
    'Chargers' : 'Chargers',
    'Rams' : 'Rams',
    'Dolphins' : 'Dolphins',
    'Vikings' : 'Vikings',
    'Patriots' : 'Patriots',
    'Saints' : 'Saints',
    'Giants' : 'Giants',
    'Jets' : 'Jets',
    'Eagles' : 'Eagles',
    'Steelers' : 'Steelers',
    '49ers' : '49ers',
    'Seahawks' : 'Seahawks',
    'Buccaneers' : 'Buccaneers',
    'Titans' : 'Titans',
    'Commanders' : 'Commanders',
    'NEW' : 'New',
    //Soccer_Soccer3_Turkish_League team names and game name
    "Soccer_Soccer3_Turkish_League": "Türkiye Ligi",
    "Basaksehir": "BAS",
    "Trabzon": "TRZ",
    "Besiktas": "BKS",
    "Sivas": "SIV",
    "Alanya": "ALA",
    "Galata": "GLS",
    "Fenerbahce": "FRB",
    "Gazientep": "GAZ",
    "Antalya": "ANT",
    "Kasimpasa": "KAS",
    "Goztepe": "GOZ",
    "Gencler": "ESK",
    "Konya": "BUR",
    "Rize": "RIZ",
    "Malatya": "MAL",
    "Kayseri": "KAY",

    //NBA 
  "Basketball_NBA": "NBA",
  "Atlanta Hawks": "Atlanta Hawks",
  "Boston Celtics": "Boston Celtics",
  "Brooklyn Nets": "Brooklyn Nets",
  "Charlotte Hornets": "Charlotte Hornets",
  "Chicago Bulls": "Chicago Bulls",
  "Cleveland Cavaliers": "Cleveland Cavaliers",
  "Dallas Mavericks": "Dallas Mavericks",
  "Denver Nuggets": "Denver Nuggets",
  "Detroit Pistons": "Detroit Pistons",
  "Golden State Warriors": "Golden State Warriors",
  "Houston Rockets": "Houston Rockets",
  "Indiana Pacers": "Indiana Pacers",
  "Los Angeles Clippers": "Los Angeles Clippers",
  "Los Angeles Lakers": "Los Angeles Lakers",
  "Memphis Grizzlies": "Memphis Grizzlies",
  "Miami Heat": "Miami Heat",
  "Milwaukee Bucks": "Milwaukee Bucks",
  "Minnesota Timberwolves": "Minnesota Timberwolves",
  "New Orleans Pelicans": "New Orleans Pelicans",
  "New York Knicks": "New York Knicks",
  "Oklahoma City Thunder": "Oklahoma City Thunder",
  "Orlando Magic": "Orlando Magic",
  "Philadelphia 76ers": "Philadelphia 76ers",
  "Phoenix Suns": "Phoenix Suns",
  "Portland Trail Blazers": "Portland Trail Blazers",
  "Sacramento Kings": "Sacramento Kings",
  "San Antonio Spurs": "San Antonio Spurs",
  "Toronto Raptors": "Toronto Raptors",
  "Utah Jazz": "Utah Jazz",
  "Washington Wizards": "Washington Wizards",
  "TOTALPOINTS": "TOTAL POINTS"
};


// WEBPACK FOOTER //
// ./src/localization/tr_TR.js